import React,{useState, useEffect} from 'react';
import './App.css';
import {MenuItem,FormControl,Select, Card} from '@material-ui/core'
import InfoBox from './InfoBox'
import Map from './Map'
import Table from './Table'
import LineGraph from './LineGraph'
import {CardContent,Typography} from '@material-ui/core'
import {sortData,prettyPrintStat} from './util'
import 'leaflet/dist/leaflet.css'
import numeral from 'numeral'


function App() {

const [countries,setCountries]=useState([])
const [country,setCountry]=useState("worldwide");
const [countryInfo,setCountryInfo]=useState({});
const [tableData,setTableData]=useState([]);
const [mapCenter,setMapCenter]=useState({lat:34.80746, lng:-40.4796});
const [mapZoom,setMapZoom]=useState(3);
const [mapCountries,setMapCountries]=useState([]);
const [casesType,setCasesType]=useState('cases')





  useEffect(()=>{
    fetch('https://disease.sh/v3/covid-19/all')
    .then(response=>response.json())
    .then(data=>{
      setCountryInfo(data);
    })
  },[])



  useEffect(()=>{
    const getCountriesData=async()=>{
      await fetch('https://disease.sh/v3/covid-19/countries')
      .then((response)=>response.json())
      .then((data)=>{
        const countries=data.map((country)=>(
          {
            name:country.country,
            value:country.countryInfo.iso2
          }
        ));

        const sortedData=sortData(data)
        setTableData(sortedData);
        setMapCountries(data)
        setCountries(countries);
      });
    };
    getCountriesData();
  }
    ,[]);

const onCountryChange=async(event)=>{
  const countryCode=event.target.value;
  setCountry(countryCode)

  //if country code is worldwide then fetch data from 
  //https://disease.sh/v3/covid-19/all
  //else fetch from
  //https://disease.sh/v3/covid-19/countries/[COUNTRY_CODE]
  const url=countryCode==='worldwide' ? 'https://disease.sh/v3/covid-19/all' :
 `https://disease.sh/v3/covid-19/countries/${countryCode}`;

 await fetch(url)
 .then(response=>response.json())
 .then(data=>{
   setCountry(countryCode);
   //All data from the country response
   setCountryInfo(data);
   setMapCenter([data.countryInfo.lat,data.countryInfo.long])
   setMapZoom(5);
 })
console.log(countryInfo);
};


  return (
    <div className="app">

    <div className='app__left'>
    <div className="app_header">

    {/*Header */}
    {/* Title and Region */}
      <h1>COVID-19 TRACKER<h6>by Bala</h6></h1>
      <FormControl className='app_dropdown'>
        <Select
        variant='outlined'
        onChange={onCountryChange}
        value={country}
        >
        <MenuItem value='worldwide'>Worldwide</MenuItem>
        {
          countries.map((country)=>(
            <MenuItem value={country.value}>{country.name}</MenuItem>
          ))
        }
        </Select>
      </FormControl>
      </div>

    {/*InfoBoxes */}
    <div className='app__stats'>
      <InfoBox 
      active={casesType==="cases"}
      onClick={e=>setCasesType('cases')}
      title='Coronavirus Cases' 
      cases={prettyPrintStat(countryInfo.todayCases)} 
      total={numeral(countryInfo.cases).format("0,k")}/>

      <InfoBox 
        active={casesType==="recovered"}
       onClick={e=>setCasesType('recovered')}
      title='Recovered' 
      cases={prettyPrintStat(countryInfo.todayRecovered)} 
      total={numeral(countryInfo.recovered).format("0,k")}/>

      <InfoBox 
      active={casesType==="deaths"}
      onClick={e=>setCasesType('deaths')}
      title='Deaths' 
      cases={prettyPrintStat(countryInfo.todayDeaths)} 
      total={numeral(countryInfo.deaths).format("0,k")}/>
    </div>
    {/*Map */}
    <Map
    casesType={casesType}
    countries={mapCountries}
      center={mapCenter}
      zoom={mapZoom}
    />
    </div>

  <Card className='app__right'>
    
    <CardContent>
      <h3>Live cases by Country</h3>
      {/*Table */}
      <Table countries={tableData}/>
      <h3 className='app__graphTitle'>Worldwide new {casesType}</h3>
      {/*Graph */}
      <LineGraph className='app__graph' casesType={casesType}/>
    </CardContent>

  </Card>
</div>
  

  );
}

export default App;
